const angular = require('angular');
const app = angular.module('learn-services');
/**
 * Overwrite authInterceptor for the purposes of injecting the authtoken as needed
 * @argument {$q} $q Angular's promise library
 * @argument {Application} Application is the application main service with core functionalities and utilities
 */
app.factory('authInterceptor', ['$q', 'Access', 'Navigation', function($q, Access, Navigation) {
    const authTransitionRoutes = ['/saml-transition', '/oauth-transition'];
    return {
      request: function(config) {
        config.headers = config.headers || {};

        if (config.headers['Remove-auth']) {
          delete config.headers['Remove-auth'];
          return config;
        }
        if (!Navigation.isRouteSecure() && authTransitionRoutes.indexOf(Navigation.getPath()) === -1) {
          return config;
        }
        let authtokenRecord = Access.getAuthtoken();
        if (!authtokenRecord && !Navigation.getUrlParameters().authtoken) {
          return config;
        } 
        let token = authtokenRecord ? authtokenRecord.authtoken : Navigation.getUrlParameters().authtoken;
        if (!token) {
          return config;
        }
        config.headers['Authorization'] = 'AuthToken token=' + token;
        return config;
      },
      response: function(response) {
        if (response.status === 403) {
          Navigation.goToSignIn();
        }
        return response || $q.when(response);
      },
      responseError: function(rejection) {
        if (rejection.status === 403) {
          Navigation.goToSignIn();
        }
        return $q.reject(rejection);
      }
    };
  }]);